<script>
  import { onMount } from 'svelte';
  import { Router, Link, link, Route } from "svelte-routing";
  import { globalHistory } from 'svelte-routing/src/history';
  import { default as Novinky } from './novinky.svelte';
  import { default as Wines } from './wines.svelte';
  import { default as Companies } from './companies.svelte';
  import { default as Detail } from './detail.svelte';
  import { default as Index } from './index.svelte';
  
  let url = window.location.pathname;
  let fulltext = '';
  
  let base_category_ids = [62];
  
  let query = new URLSearchParams(window.location.search);
  
  function getCategoriesFromQuery(defaultOnes) {
    let ids = query.get('categories');
    if (ids && ids.length > 2)
      return JSON.parse(ids);
    if (!defaultOnes)
      defaultOnes = [];
    return defaultOnes;
  }
  
  globalHistory.listen(history => {
    url = window.location.pathname;
  });
</script>
<div class='px-4' id='header-wrapper'>
<!-- Header -->
<div class='container'>
<div class='row py-2'>
<div class='col-7 col-md-5'>
<img alt='Demijón' class='img-fluid' src='/img/demi-logo-shadow.png' title='Demijón' width='100%'>
</div>
<div class='col-12 col-md-7 d-flex flex-column justify-content-end'>
<blockquote class='blockquote text-right text-white d-none d-lg-inline mb-4'>
<p class='mb-1 font-italic text-shadow'>"Je&nbsp;příliš&nbsp;pozdě&nbsp;myslet&nbsp;na&nbsp;víno, když&nbsp;je&nbsp;sud&nbsp;prázdný."</p>
<footer class='blockquote-footer text-white text-shadow'>
<cite>Slovanské přísloví</cite>
</footer>
</blockquote>
<div class='mb-3'>
<form class='form-inline float-right'>
<div class='input-group'>
<input aria-label='Search' bind:value='{fulltext}' class='form-control' placeholder='Název, město, ulice aj.' type='search'>
<div class='input-group-append'>
<a class='btn btn-success' href='/hledani?q={fulltext}' use:link>
<i class='fa fa-search'></i>
<div class='d-none d-md-inline'>
Hledat
</div>
</a>
</div>
</div>
</form>
</div>
</div>
</div>
<div class='row'>
<div class='col-12 d-flex flex-row justify-content-between'>
<ul class='nav nav-tabs' id='main-tab'>
<li class='nav-item'>
<a class:active='{url=="/"}' class='nav-link' href='/'>
<i class='fa fa-home'></i>
</a>
</li>
<li class='nav-item'>
<a class:active='{url=='/vinarstvi-vinoteky'}' class='nav-link' href='/vinarstvi-vinoteky' use:link>Vinaři a vinotéky</a>
</li>
<li class='nav-item'>
<a class:active='{url=='/rekreace'}' class='nav-link' href='/rekreace' use:link>Rekreace</a>
</li>
<li class='nav-item'>
<a class:active='{url=='/vino'}' class='nav-link' href='/vino'>Víno</a>
</li>
</ul>
<ul class='nav nav-tabs main-tabs'>
<li class='nav-item' id='login'>
<a class:active='{url=='/profil'}' class='nav-link' href='/profil'>
<i class='fa fa-unlock-alt'></i>
<div class='d-none d-sm-inline'>
&nbsp;&nbsp;Členové
</div>
</a>
</li>
</ul>
</div>
</div>
</div>

</div>
<div class='px-4' id='main'>
<div class='container'>
<Router url='{url}'>
<Route let:params path='/'>
<Index></Index>
</Route>
<Route let:params path='/vinarstvi-vinoteky'>
<Companies base_category_ids='{[63]}' category_ids='{getCategoriesFromQuery([44,43])}' json_url='/subjects.json'></Companies>
</Route>
<Route let:params path='/rekreace'>
<Companies base_category_ids='{[53]}' category_ids='{getCategoriesFromQuery([45,46,53])}' json_url='/subjects.json'></Companies>
</Route>
<Route let:params path='/firma/:slug'>
<Detail slug='{params.slug}'></Detail>
</Route>
<Route let:params path='/vino'>
<Wines base_category_ids='{[48]}' json_url='/subjects.json'></Wines>
</Route>
<Route let:params path='/hledani'>
<Companies base_category_ids='{base_category_ids}' json_url='/fulltext.json' query_string='&q={fulltext}'></Companies>
</Route>
</Router>
</div>
</div>
